module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      "page",
      ("page--c" + _vm.random),
      _vm.appPage.classes,
      {
        'page--is-loaded': _vm.appState.loaded,
        'page--is-loading': _vm.appState.loading,
        'page--show-group': !_vm.appState.loading,
      } ],
    attrs: {
      "id": "app",
      "data-env": _vm.appEnv
    }
  }, [_c('ui-header'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "component-fade",
      "mode": "out-in"
    },
    on: {
      "appear": function($event) {
        return _vm.onLoad()
      },
      "enter": function($event) {
        return _vm.onLoad()
      },
      "leave": function($event) {
        return _vm.onLeave()
      }
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1), _vm._v(" "), _c('ui-footer'), _vm._v(" "), _c('ui-loader')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63713ffd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue
// module id = 38
// module chunks = 1